/**
 * Route for `cross-device`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CrossDevicePage } from "../features/cross-device/CrossDevicePage";

export const crossDeviceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cross-device",
	component: CrossDevicePage,
});

export default crossDeviceRoute;
